import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Column, Row } from 'simple-flexbox';
import './App.css';
import HeaderComponent from './Components/HeaderComponent';
//import {NavBar} from "./navigation/components";
import RouterConfig from "./navigation/RouterConfig";
import { SidebarComponent, SidebarContext } from './navigation/sidebar';
import { default as Typography } from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { default as Box } from '@mui/material/Box';

const useStyles = createUseStyles({
  container: {
    height: '100vh',
    // minHeight: 500
  },
  mainBlock: {
    marginLeft: 0,
    // '@media (max-width: 1080px)': {
    //   marginLeft: 0
    // },
    // wrap: true,  
    display: 'flex',
    flexDirection: 'column', 
    height: '100vh',
    width: '100%'
  },
  contentBlock: {
    // marginTop: 10,
    // height: '100%'
  }
});

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://maatek.dk">
        Maatek Systems
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

function App() {
  // // const theme = useTheme();
  // // const classes = useStyles({ theme });
  const classes = useStyles();

  console.log(process.env.NODE_ENV)

  return (
    <SidebarContext>
      <Row className={classes.container}>
        <SidebarComponent />
        <Box className={classes.mainBlock}>
          <HeaderComponent />          
          <RouterConfig />        
          <Box component="footer" sx={{ p: 2, bgcolor: '#eaeff1' }}>
            <Copyright />
          </Box>
        </Box>
      </Row>
    </SidebarContext>
  );
}

export default App;
